import { AbstractEntity } from '../AbstractEntity'

export class InnerContractNo extends AbstractEntity {
  /**
   * @param {Object} data
   */
  constructor(data) {
    super(data)
  }
  get innerContractNo() {
    return this._data.innerContractNo
  }
  set innerContractNo(innerContractNo) {
    this._data.innerContractNo = innerContractNo
  }
  get regions() {
    return this._data.regions
  }
  set regions(regions) {
    this._data.regions = regions
  }
  get active() {
    return this._data.active
  }
  set active(active) {
    this._data.active = active || false
  }
}
